// extracted by mini-css-extract-plugin
module.exports = {"root":"AccountActionsBan_root__coCC1"};